<i18n>
{
	"en": {
		"defaultOperationalDepartment": "Operating",
		"departments": "Default departments",
		"defaultEconomicalDepartment": "Economical"
	},
	"no":{
		"defaultOperationalDepartment": "Operativ",
		"departments": "Standard avdelinger",
		"defaultEconomicalDepartment": "Økonomisk"
	}
}
</i18n>

<template>
	<div class="details">
		<t-form-group :title="$t('departments')" :horizontal="true">
			<t-text-input
				v-model="edisetup.defaultEconomicalDepartment.departmentName"
				disabled
				:label="$t('defaultEconomicalDepartment')"
			/>
			<t-text-input
				v-model="edisetup.defaultOperationalDepartment.departmentName"
				disabled
				:label="$t('defaultOperationalDepartment')"
			/>
		</t-form-group>

	</div>
</template>

<script>

export default {
	name: 'Departments',
	props: {
		edisetup: Object
	}
};
</script>

<style lang="scss" scoped>

.details{

}
</style>